import { render } from "./CustomerHome.vue?vue&type=template&id=2ce7c6a6&scoped=true"
import script from "./CustomerHome.vue?vue&type=script&lang=js"
export * from "./CustomerHome.vue?vue&type=script&lang=js"

import "./CustomerHome.vue?vue&type=style&index=0&id=2ce7c6a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce7c6a6"]])

export default __exports__